import React from 'react';
import { IconWarning } from '@americanexpress/dls-react';

function GenericError() {
    return (
        <>
            <div className="flex flex-justify-center">
                <div className="col-xs-12 text-align-center margin-4-t">
                    <IconWarning
                        size="lg"
                        theme={{
                            color: '#a83025 !important',
                            fill: '#a83025 !important'
                        }}
                    />
                </div>
            </div>
            <div className="col-xs-12 text-align-center">
                <p className="heading-4 pad dls-gray-04">We are sorry</p>
            </div>
            <div className="col-xs-12 text-align-center">
                <p className="label-3 pad">At this time we are unable to process your request.
                    Please access your email link to re-enter the application process.</p>
            </div>
        </>
    );
}

export default GenericError;